
import { Form24Regular, Form24Filled ,bundleIcon} from "@fluentui/react-icons";

export const FormIcon = bundleIcon(Form24Filled, Form24Regular);